if (!customElements.get('scent-description')) {
  class ScentDescription extends HTMLElement {
  constructor() {
    super();
    this.variantChangeUnsubscriber = undefined;
    
    const scriptEl = this.querySelector('script[type="application/json"]');
    if (scriptEl) {
      try {
        this.scentMetafieldData = JSON.parse(scriptEl.textContent);
      } catch (error) {
        console.error('Error parsing scent description data:', error);
        this.scentMetafieldData = {};
      }
    } else {
      this.scentMetafieldData = {};
    }

    this.span = this.querySelector('span');
  }

  connectedCallback() {
    // Subscribe to variant change events using the pub/sub system
    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.variantChangeUnsubscriber = subscribe(
        PUB_SUB_EVENTS.variantChange,
        this.handleVariantChange.bind(this)
      );
    }
  }

  disconnectedCallback() {
    if (this.variantChangeUnsubscriber) {
      this.variantChangeUnsubscriber();
    }
  }

  handleVariantChange(event) {
    if (!event?.data?.variant) return;
    
    const variant = event.data.variant;
    // Handle both string and number variant IDs
    const variantId = variant.id?.toString();
    
    // Get scent description from our JSON data first
    let scentDescription = this.scentMetafieldData[variantId];
    
    // If not found in JSON data, try to get it from the variant object
    if (!scentDescription && variant?.metafields?.custom?.scent_description) {
      const metafield = variant.metafields.custom.scent_description;
      // Handle both object with .value property and direct string
      scentDescription = metafield?.value || metafield || '';
    }
    
    // Ensure it's a string (handle case where it might be an object)
    if (typeof scentDescription === 'object' && scentDescription !== null) {
      scentDescription = scentDescription.value || scentDescription.toString() || '';
    } else {
      scentDescription = scentDescription || '';
    }
    
    if (this.span) {
      this.span.textContent = scentDescription;
      // Hide the element if there's no scent description
      if (scentDescription) {
        this.style.display = '';
      } else {
        this.style.display = 'none';
      }
    }
  }
  }

  customElements.define('scent-description', ScentDescription);
}
 